/**
 * Browser-local cache of wishlisted listing IDs to reduce Firestore reads on repeat visits.
 * Full item documents still sync via realtime listener when authenticated.
 */

import { WISHLIST_CACHE_KEY } from '../../firebase/config';

const readRaw = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    const raw = window.localStorage.getItem(WISHLIST_CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

/**
 * @param {string} userId
 * @returns {string[]}
 */
export const getCachedWishlistIds = userId => {
  const data = readRaw();
  if (!data || data.userId !== userId) {
    return [];
  }
  return Array.isArray(data.listingIds) ? data.listingIds : [];
};

/**
 * @param {string} userId
 * @param {string[]} listingIds
 */
export const setCachedWishlistIds = (userId, listingIds) => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.setItem(
      WISHLIST_CACHE_KEY,
      JSON.stringify({
        userId,
        listingIds,
        updatedAt: Date.now(),
      })
    );
  } catch {
    // Quota exceeded or private mode — ignore
  }
};

export const clearWishlistCache = () => {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.localStorage.removeItem(WISHLIST_CACHE_KEY);
  } catch {
    // ignore
  }
};
